// src/i18n/en/wall.ts
// English mirror of es/wall.ts.
export const wall = {
  updatedAt: 'Updated at %{time}',
  offline: 'Offline',
  offlineDescription: 'Could not refresh the information. Retrying…',
  page: 'Page %{page} of %{total}',
};

export default wall;
